import * as R from 'ramda';
import { MediaFormatEnum } from '../../../general-settings/enums/mediaFormat.enum';
import { ESProductPrice } from '../../ProductTypes';
import {
  ContainerWidths,
  GetMinMaxPrices,
  PriceTypesEnum,
  WidthSetterFunctionsParams,
} from '../types/productDetails.types';

export function allocateGroups(groups: number[], quantity: number) {
  let sum = 0;
  const newGroups = [];
  for (let i = 0; i < groups.length; i += 1) {
    sum += groups[i];

    if (sum > quantity) {
      newGroups.push(groups[i] - (sum - quantity));
      break;
    }

    newGroups.push(groups[i]);

    if (sum === quantity) {
      break;
    }
  }
  return newGroups.filter((num) => num > 0);
}

export const setOrderInfoSectionMaxWidth = ({
  gridQuantity,
  activeBreakpoint,
  horizontalTabletWidth,
}: WidthSetterFunctionsParams) => {
  const orderInfoSectionWidths: ContainerWidths = {
    smallWidth: { width: 185, maxWidth: 185 },
    bigWidth: { width: 325, maxWidth: 325 },
    tabletSmallWidth: { width: 165, maxWidth: 165 },
    tabletBigWidth: { width: 235, maxWidth: 235 },
  };

  if (horizontalTabletWidth) {
    return gridQuantity > 7 ? orderInfoSectionWidths.smallWidth : orderInfoSectionWidths.bigWidth;
  }

  switch (activeBreakpoint) {
    case 'xl':
      return gridQuantity > 7 ? orderInfoSectionWidths.smallWidth : orderInfoSectionWidths.bigWidth;
    case 'md':
      return gridQuantity > 7
        ? orderInfoSectionWidths.tabletSmallWidth
        : orderInfoSectionWidths.tabletBigWidth;
    case 'lg':
      return gridQuantity > 3 ? orderInfoSectionWidths.smallWidth : orderInfoSectionWidths.bigWidth;
    case 'sm':
      return gridQuantity > 2
        ? orderInfoSectionWidths.tabletSmallWidth
        : orderInfoSectionWidths.tabletBigWidth;
    default:
      return orderInfoSectionWidths.smallWidth;
  }
};

export const getMinMaxPrice = (
  priceType: PriceTypesEnum,
  prices?: ESProductPrice[] | null,
): GetMinMaxPrices => {
  if (!prices?.length) {
    return;
  }

  const validPrices = prices
    .map((obj) => {
      const price = obj[priceType];
      return !R.isNil(price) && !isNaN(Number(price)) ? Number(price) : null;
    })
    .filter((price): price is number => price !== null);

  if (!validPrices.length) {
    return;
  }

  return {
    min: Math.min(...validPrices),
    max: Math.max(...validPrices),
  };
};

export const getGalleryWidth = (mediaFormat: MediaFormatEnum, modalHeight: number) => {
  if (mediaFormat === MediaFormatEnum.RECTANGULAR) {
    return '37.3%';
  }
  return `${(3 / 4) * modalHeight}px`;
};
